










import { Component, Vue } from "vue-property-decorator";

@Component
export default class ShareLink extends Vue {
  copyShareUrl() {
    const inp = this.$refs.shareUrl as HTMLInputElement;
    inp.focus();
    inp.select();
    document.execCommand("copy");
  }

  get currentHref() {
    return window.location.href;
  }
}
